import React, {
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useContext,
    useState,
} from "react";

// -------------------------------------------------------------------------------------------------
// #region Types
// -------------------------------------------------------------------------------------------------

export type GroupUpdater = Dispatch<SetStateAction<TeamOnboardingDetails>>;

export interface TeamOnboardingDetails {
    groupId: number | null;
    teamName: string;
    isNewTeam: boolean;
}

// #endregion Types

// -------------------------------------------------------------------------------------------------
// #region Context
// -------------------------------------------------------------------------------------------------

export const defaultState: TeamOnboardingDetails = {
    groupId: null,
    teamName: "",
    isNewTeam: false,
};
const defaultUpdater: GroupUpdater = () => {};

export const GroupContext = createContext<
    [TeamOnboardingDetails, GroupUpdater]
>([defaultState, defaultUpdater]);

// #endregion Context

// -------------------------------------------------------------------------------------------------
// #region Provider
// -------------------------------------------------------------------------------------------------

const GroupContextProvider = (props: PropsWithChildren<{}>) => {
    const [teamOnboardingDetails, setTeamOnboardingDetails] =
        useState<TeamOnboardingDetails>(defaultState);

    return (
        <GroupContext.Provider
            value={[teamOnboardingDetails, setTeamOnboardingDetails]}>
            {props.children}
        </GroupContext.Provider>
    );
};

// #endregion Provider

// -------------------------------------------------------------------------------------------------
// #region Hook
// -------------------------------------------------------------------------------------------------

export const useGroupContext = () => {
    const [groupContext, setGroupContext] = useContext(GroupContext);

    return {
        groupContext,
        setGroupContext,
    };
};

// #endregion Hook

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default GroupContextProvider;

// #endregion Exports
